"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mega Matcher ID management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024.2.0
 * Contact: support@neurotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationStatus = exports.OperationOperationType = exports.OperationModality = exports.OperationLivenessMode = exports.OperationIcaoWarnings = void 0;
exports.OperationIcaoWarnings = {
    NoWarnings: 'NO_WARNINGS',
    FaceNotDetected: 'FACE_NOT_DETECTED',
    RollLeft: 'ROLL_LEFT',
    RollRight: 'ROLL_RIGHT',
    YawLeft: 'YAW_LEFT',
    YawRight: 'YAW_RIGHT',
    PitchUp: 'PITCH_UP',
    PitchDown: 'PITCH_DOWN',
    TooNear: 'TOO_NEAR',
    TooFar: 'TOO_FAR',
    TooNorth: 'TOO_NORTH',
    TooSouth: 'TOO_SOUTH',
    TooEast: 'TOO_EAST',
    TooWest: 'TOO_WEST',
    Sharpness: 'SHARPNESS',
    BackgroundUniformity: 'BACKGROUND_UNIFORMITY',
    GrayscaleDensity: 'GRAYSCALE_DENSITY',
    Saturation: 'SATURATION',
    Expression: 'EXPRESSION',
    DarkGlasses: 'DARK_GLASSES',
    EyesClosed: 'EYES_CLOSED',
    MouthOpen: 'MOUTH_OPEN',
    LookingAway: 'LOOKING_AWAY',
    RedEye: 'RED_EYE',
    FaceDarkness: 'FACE_DARKNESS',
    UnnaturalSkintone: 'UNNATURAL_SKINTONE',
    WashedOut: 'WASHED_OUT',
    Pixelation: 'PIXELATION',
    SkinReflection: 'SKIN_REFLECTION',
    GlassesReflection: 'GLASSES_REFLECTION',
    HeavyFrame: 'HEAVY_FRAME',
    OcclusionWarning: 'OCCLUSION_WARNING',
    ResolutionWarning: 'RESOLUTION_WARNING',
    MotionBlurWarning: 'MOTION_BLUR_WARNING',
    CompressionArtifactsWarning: 'COMPRESSION_ARTIFACTS_WARNING',
    Overexposure: 'OVEREXPOSURE',
    Underexposure: 'UNDEREXPOSURE',
    Glasses: 'GLASSES',
    Hat: 'HAT',
    HeadMovement: 'HEAD_MOVEMENT',
    ImageResolution: 'IMAGE_RESOLUTION',
    Unrecognized: 'UNRECOGNIZED'
};
exports.OperationLivenessMode = {
    DoNotDetect: 'DO_NOT_DETECT',
    Passive: 'PASSIVE',
    Active: 'ACTIVE',
    PassiveAndActive: 'PASSIVE_AND_ACTIVE',
    Simple: 'SIMPLE',
    Custom: 'CUSTOM',
    PassiveWithBlink: 'PASSIVE_WITH_BLINK',
    Unrecognized: 'UNRECOGNIZED'
};
exports.OperationModality = {
    FaceModality: 'FACE_MODALITY',
    VoiceModality: 'VOICE_MODALITY',
    FingersLeftHandModality: 'FINGERS_LEFT_HAND_MODALITY',
    FingersRightHandModality: 'FINGERS_RIGHT_HAND_MODALITY',
    Unrecognized: 'UNRECOGNIZED'
};
exports.OperationOperationType = {
    Unspecified: 'UNSPECIFIED',
    Verify: 'VERIFY',
    Checks: 'CHECKS',
    CreateTemplate: 'CREATE_TEMPLATE',
    ReextractTemplate: 'REEXTRACT_TEMPLATE',
    Unrecognized: 'UNRECOGNIZED'
};
exports.OperationStatus = {
    None: 'NONE',
    Success: 'SUCCESS',
    Timeout: 'TIMEOUT',
    Canceled: 'CANCELED',
    BadQuality: 'BAD_QUALITY',
    MatchNotFound: 'MATCH_NOT_FOUND',
    CameraNotFound: 'CAMERA_NOT_FOUND',
    FaceNotFound: 'FACE_NOT_FOUND',
    LivenessCheckFailed: 'LIVENESS_CHECK_FAILED',
    BadSharpness: 'BAD_SHARPNESS',
    TooNoisy: 'TOO_NOISY',
    BadLightning: 'BAD_LIGHTNING',
    Occlusion: 'OCCLUSION',
    BadPose: 'BAD_POSE',
    TooManyObjects: 'TOO_MANY_OBJECTS',
    MaskDetected: 'MASK_DETECTED',
    DuplicateFound: 'DUPLICATE_FOUND',
    DuplicateId: 'DUPLICATE_ID',
    MotionBlur: 'MOTION_BLUR',
    CompressionArtifacts: 'COMPRESSION_ARTIFACTS',
    TooDistant: 'TOO_DISTANT',
    TooClose: 'TOO_CLOSE',
    Failed: 'FAILED',
    Initialized: 'INITIALIZED',
    JanusUnknownError: 'JANUS_UNKNOWN_ERROR',
    JanusPluginError: 'JANUS_PLUGIN_ERROR',
    JanusNotFound: 'JANUS_NOT_FOUND',
    JanusBadRequest: 'JANUS_BAD_REQUEST',
    JanusIceFailed: 'JANUS_ICE_FAILED',
    ResolutionInsufficient: 'RESOLUTION_INSUFFICIENT',
    ChunkReceiveTimeout: 'CHUNK_RECEIVE_TIMEOUT',
    StreamDecodeFailed: 'STREAM_DECODE_FAILED',
    AdjustingQuality: 'ADJUSTING_QUALITY',
    InternalError: 'INTERNAL_ERROR',
    Unrecognized: 'UNRECOGNIZED'
};
